<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative min-h-496px w-full>
    <svg
      :class="v && 'animated-fade-in-left'"
      absolute animated
      class="left-[clamp(-10000px,calc((100vw-1920px)/1.91+0px),0px)]"
      lg="left-[clamp(-10000px,calc((100vw-1920px)/2.2+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="496" viewBox="0 0 1131 496" fill="none"
    >
      <path d="M0 0H1131L788.5 496H0V0Z" fill="#CE0000" />
    </svg>

    <div relative container col justify-center lg:items-center>
      <div mt-24px lg:mt-98px>
        <p class="text-35px font-bold lh-100% lg:text-80px" :class="v && 'animated-fade-in-left'" animated>
          SPONSORSHIP BENEFITS
        </p>
        <p :class="v && 'animated-fade-in-left'" mt-20px text-24px font-bold animated animated-delay-200 lg:text-53px>
          BECOME A SPONSOR
        </p>
        <div absolute left-8 mt-14px>
          <div row>
            <div class="anim grid grid-cols-[repeat(11,160px)] gap-14px">
              <img src="/images/image-1417.webp" alt="">
              <img src="/images/image-1417-2.webp" alt="">
              <img src="/images/image-1417-3.webp" alt="">
              <img src="/images/image-1417-4.webp" alt="">
              <img src="/images/image-1417-5.webp" alt="">
              <img src="/images/image-1417-6.webp" alt="">
              <img src="/images/image-1417-7.webp" alt="">
              <img src="/images/image-1417-8.webp" alt="">
              <img src="/images/image-1417-9.webp" alt="">
              <img src="/images/image-1417-10.webp" alt="">
              <img src="/images/image-1417-11.webp" alt="">
            </div>

            <div class="grid grid-cols-[repeat(11,160px)] ml-14px gap-14px">
              <img src="/images/image-1417.webp" alt="">
              <img src="/images/image-1417-2.webp" alt="">
              <img src="/images/image-1417-3.webp" alt="">
              <img src="/images/image-1417-4.webp" alt="">
              <img src="/images/image-1417-5.webp" alt="">
              <img src="/images/image-1417-6.webp" alt="">
              <img src="/images/image-1417-7.webp" alt="">
              <img src="/images/image-1417-8.webp" alt="">
              <img src="/images/image-1417-9.webp" alt="">
              <img src="/images/image-1417-10.webp" alt="">
              <img src="/images/image-1417-11.webp" alt="">
            </div>
          </div>
        </div>
        <p :class="v && 'animated-fade-in-left'" mt-194px max-w-480px animated animated-delay-300 lt-lg:text-10px>
          Miss W Korea Edition offers a number of bespoke sponsorship packages tailored to your organization’s marketing needs and budget, including Ambassador promotion, Media coverage, and Brand exposure.
          <br>
          <br>
          Request the Sponsorship Deck from us to get access to the best branding for Miss W Korea Edition.
        </p>

        <button lt-lg="hidden" class="p-[20px_24px]" mt-20px btn w-295px uppercase :class="v && 'animated-fade-in-down'" animated animated-delay-300>
          JOIN AS SPONSOR
        </button>
      </div>
    </div>

    <button :class="v && 'animated-fade-in-down'" class="p-[20px_24px]" absolute inset-x-0 bottom--60px mx-auto block btn w-295px uppercase animated animated-delay-300 lg:hidden>
      JOIN AS SPONSOR
    </button>
  </div>
</template>

<style scoped lang="scss">
@keyframes fadeInLeft {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -50%;
  }
}

.anim {
  animation: fadeInLeft 20s ease-out both alternate infinite;
}
</style>
